import common_es from './common.json';
import pages_es from './pages.json';

export default {
  common: common_es,
  pages: pages_es,
};
